var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "25px",
    viewBox: "0 0 23 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Player-Added-+-Player's-List-(After-Dragging)-(Desktop)",
    transform: "translate(-752.000000, -453.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rating-Badge-(Desktop)",
    transform: "translate(752.000000, 453.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.98482832 L0,17.7535268 C0,18.0729305 0.182954545,18.4189513 0.444318182,18.6052702 L11.3431818,24.8602608 C11.6568182,25.0465797 11.9965909,25.0465797 12.3102273,24.8602608 L22.5556818,18.6052702 C22.8170455,18.4189513 23,18.1527815 23,17.7535268 L23,0.98482832 C23,0.452488688 22.5556818,0 22.0329545,0 L0.967045455,0 C0.444318182,0 0,0.452488688 0,0.98482832 Z",
    id: "Path",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingBadge);
export default __webpack_public_path__ + "static/media/rating-badge.693cd4ec0f1d89bae464e30434ba0357.svg";
export { ForwardRef as ReactComponent };